import { async } from "regenerator-runtime";
import { API_URL, FINALISTS_CATEGORIES } from "./config.js";
import { AJAX } from "./helpers.js";

/* 
?eid=1598&win=1&link=00000000 = load all winners
?eid=1598&win=1&link=00000000
*/

export const state = {
	products: {
		content: [],
		finalists: [],
		categories: 0,
		catIcons: {
			1: "cream",
			2: "profile",
			3: "cup",
		},
		medals: {
			1: "gold",
			2: "silver",
			3: "bronze",
		},
		winners: [],
	},
};

export const loadProducts = async function (id, link) {
	try {
		const data = await AJAX(`${API_URL}?eid=${id}&link=${link}`);

		state.products.content = data;

		state.products.categories = new Map(data.map((product) => [product.categoryID, product.categoryTitle]));

		state.products.content = data.map((rec) => {
			return {
				categoryID: rec.categoryID,
				categoryTitle: rec.categoryTitle,
				subCategoryID: rec.subCategoryID,
				description: rec.description,
				id: rec.id,
				place: rec.place,
				placeTitle: state.products.medals[rec.place],
				imgFile: rec.img,
				title: rec.title,
				finalist: FINALISTS_CATEGORIES.includes(rec.subCategoryID) ? true : false,
			};
		});
	} catch (err) {
		// Temp error handling
		console.error(`${err} 💥💥💥💥`);
		throw err;
	}
};

export const loadWinners = async function (id, link) {
	try {
		const data = await AJAX(`${API_URL}?eid=${id}&win=1&link=${link}`);

		state.products.winners = data.map((rec) => {
			return {
				categoryID: rec.categoryID,
				categoryTitle: rec.categoryTitle,
				subCategoryID: rec.subCategoryID,
				description: rec.description,
				id: rec.id,
				place: rec.place,
				placeTitle: state.products.medals[rec.place],
				imgFile: rec.img,
				title: rec.title,
				finalist: FINALISTS_CATEGORIES.includes(rec.subCategoryID) ? true : false,
			};
		});
	} catch (err) {
		// Temp error handling
		console.error(`${err} 💥💥💥💥`);
		throw err;
	}
};

export const loadFinalistsCategory = async function (id, subcategory, link) {
	try {
		const data = await AJAX(`${API_URL}?eid=${id}&cid=1&ccid=${subcategory}&link=${link}`);

		state.products.finalists = data.map((rec) => {
			return {
				categoryID: rec.categoryID,
				categoryTitle: rec.categoryTitle,
				subCategoryID: rec.subCategoryID,
				description: rec.description,
				id: rec.id,
				place: rec.place,
				placeTitle: state.products.medals[rec.place],
				imgFile: rec.img,
				title: rec.title,
				finalist: FINALISTS_CATEGORIES.includes(rec.subCategoryID) ? true : false,
			};
		});
	} catch (err) {
		// Temp error handling
		console.error(`${err} 💥💥💥💥`);
		throw err;
	}
};
